module.exports = __webpack_public_path__ + "img/cloudinary-2.49710d75.jpg";